import {
    ApiClientFactory
} from '@/ApiClientFactory';
import { TENANT_API_URL } from '@/Variables';

let factory = new ApiClientFactory(TENANT_API_URL);

/**
 *
 * @namespace LoginClient
 */
export const LoginClient = {

    /**
     * Logs a user in.
     * @param {Object} headers
     * @param {Object} data
     * @param {string} data.username - The user's username, usually the email
     * @param {string} data.password - The user's password
     * @param {string} data.grant_type=password - The auth grant type
     * @param {number} data.client_id - The client id
     * @param {string} data.client_secret - The client secret
     * @returns {Promise<AxiosResponse<Object>>}  The auth request promise
     *
     */
    login(data,headers) {
        /**
         * @property {string} response.data.access_token - the access token
         */
        return factory.post('api/v4/auth/login', data,headers);
    },

};
